import request from './httpService';

const EMAIL_ENDPOINT = '/email';

const sendEmail = (data) => {
  return request({
    method: 'POST',
    url: `${EMAIL_ENDPOINT}/send`,
    data
  });
};

const previewMarketingCampaign = (data) => {
  return request({
    method: 'POST',
    url: `${EMAIL_ENDPOINT}/marketing/preview`,
    data
  });
};

const sendMarketingCampaign = (data) => {
  return request({
    method: 'POST',
    url: `${EMAIL_ENDPOINT}/marketing/send`,
    data
  });
};

const sendTestEmail = (toEmail) => {
  return request({
    method: 'POST',
    url: `${EMAIL_ENDPOINT}/test`,
    data: { toEmail }
  });
};

const getProviderStatus = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_ENDPOINT}/status`
  });
};

const getWallet = () => {
  return request({
    method: 'GET',
    url: `${EMAIL_ENDPOINT}/wallet`
  });
};

const topUpWallet = (credits, reason = 'manual_top_up') => {
  return request({
    method: 'POST',
    url: `${EMAIL_ENDPOINT}/wallet/top-up`,
    data: { credits, reason }
  });
};

export const EmailService = {
  sendEmail,
  previewMarketingCampaign,
  sendMarketingCampaign,
  sendTestEmail,
  getProviderStatus,
  getWallet,
  topUpWallet
};